import { httpConsulta } from "../../../../services/apiManagement/Http.interceptor";
import { httpConsultaGenerica } from "../../../../services/apiGeneric/Http.interceptor";
import { PostInterface, PutInterface } from "./interface/SeparationsInterface";

export const getSeparations = (data:string) => {
    return httpConsulta.get(`/getExpedicaoByCd?cd=${data}`);
}

export const putSeparations = (data:PutInterface) => {
    return httpConsulta.post(`/updateExpedicao`, data);
}

export const postSeparations = (data:PostInterface) => {
    return httpConsulta.post(`/insertTransporte`, data)
}

export const getCd = (data: string) => {
    return httpConsulta.get(`/getCdByUser?usuario=${data}`);
}

export const getUserSeparation = (data:string, user:string) => {
    return httpConsultaGenerica.post(`/${data}/ZRFC_DADOS_USUARIO`, { 
        "params": {
            "I_USUARIO": `${user}`,
        }
     });
}

export const getTransp = (data:string, numberTransp:string) => {
    return httpConsultaGenerica.post(`/${data}/ZRFC_DADOS_TRANSPORTE`, { 
        "params": {
            "I_TRANSP": `${numberTransp}`,
            }
     });
}